import client from './client';

export const businessesApi = {
  list: (params) => client.get('/businesses', { params }).then((r) => r.data),
  get: (id) => client.get(`/businesses/${id}`).then((r) => r.data),
  create: (payload) => client.post('/businesses', payload).then((r) => r.data),
  update: (id, payload) => client.put(`/businesses/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/businesses/${id}`).then((r) => r.data),
  searchGoogle: (payload) =>
    client.post('/businesses/search-google', payload).then((r) => r.data),
  // Scrape a website + AI-extract a business profile to pre-fill the form.
  scrape: (url) => client.post('/businesses/scrape', { url }).then((r) => r.data),
  // Resolve a business from its connect/invite token.
  byToken: (token) => client.get(`/businesses/by-token/${token}`).then((r) => r.data),
  // Email a client an invite to connect their social accounts.
  sendConnectInvite: (id, payload) => client.post(`/businesses/${id}/connect-invite`, payload).then((r) => r.data),
  // Sent client invites + open/click tracking for a business.
  invites: (id) => client.get(`/businesses/${id}/invites`).then((r) => r.data),
};

export default businessesApi;
